<button
  #originRef
  (click)="showPopover()"
  [class.bg-hover]="dropdownOpen"
  class="button"
  mat-icon-button
  type="button">
  <mat-icon aria-hidden="false" class="primary-icon" color="primary" svgIcon="mat:notifications_active"
            [matBadge]="unreadNotification > 0 ? unreadNotification : ''"></mat-icon>
</button>
